export default __webpack_public_path__ + "static/media/dp.d85958bf.jpeg";